module.exports = __webpack_public_path__ + "4cb83da4e00d7a3a0462e5878a5823b0.png";


//////////////////
// WEBPACK FOOTER
// ./application/adminlte/plugins/iCheck/minimal/grey@2x.png
// module id = 308
// module chunks = 0